module.exports = __webpack_public_path__ + "static/media/LV.80ffffab.png";